import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import {
    getSpaceSizeUnit, formatSpaceSize, isEmpty, storageTableExtraInfos, storageLevels, storageBus, storageMarket, storageVersionAreas,
    storageFlattenAreas, storageSpaceSizeColors
} from '../Service/Utils';

import React from 'react';
import { Row, Col, Form, Radio, Tabs, Table, Input, Pagination, Modal, Select, message, Space, Tag, Rate, Tooltip, Button, Checkbox} from 'antd';
import { FireOutlined, EditTwoTone, StarTwoTone, StarFilled} from '@ant-design/icons';
import { Link } from 'react-router-dom';

class SchemaDescView extends React.Component {


    constructor() {
        super();
        this.state = {
            schemas: [

            ],
            tableHeight: document.body.clientHeight - 330,
            tagsModal: {
                schema: '',
                visible: false,
                title: '',
                version: '',
                area: '',
                market: ''
            },
            version: '',
            level: 'all',
            area: 'all',
            areaEnter: true,
            bu: 'all',
            market: 'all',
            pageNo: 1,
            pageSize: 50,
            searchKey: '',
            checkCollect: false,
            collectorView: ''
        };
    }

    async componentDidMount() {
        const json = localStorage.getItem(`${this.props.projectName}.dataMap.schemas`);
        const params = (json === undefined || json === null)
            ? {
                version: '',
                level: 'all',
                area: 'all',
                market:'all',
                bu: 'all',
                pageNo: 1,
                pageSize: 50,
                searchKey: '',
            }
            : JSON.parse(json);
       const user =  await auth.authenticate();

        this.setState({userName: user.account})
        this.setState(params, ()=>this.commitTableQuery({}));

        window.onresize = () => {
            const tableHeight = document.body.clientHeight - (this.isDefaultProject() ? 330 : 220);
            this.setState({ tableHeight })
        }
        window.onresize();
        auth.appendLog('数据地图-数据仓库');
    }

    componentWillUnmount() {
        delete window.onresize;
    }

    render() {
        return <>
            <Row>
                {this.isDefaultProject() && <Tabs
                    defaultActiveKey="dataStorage"
                    activeKey={this.state.version}
                    onChange={version => {
                        this.commitTableQuery({ version, collectorView: ''})
                        this.setState({checkCollect: false})
                    }}
                    style={{ height: 120, width: '100%' }}
                >
                    <Tabs.TabPane tab="数仓" key="dataStorage">
                    <SearchView
                            levels={[
                                { key: 'DWD/DW', title: 'DWD/DW' },
                                { key: 'DWS', title: 'DWS' },
                                { key: 'ADS/DM', title: 'ADS/DM' },
                                { key: 'DIM', title: 'DIM' }
                            ]}
                            areas={storageVersionAreas['dataStorage']}
                            bus={undefined}
                            markets={undefined}
                            level={this.state.level}
                            area={this.state.area}
                            areaEnter={this.state.areaEnter}
                            bu={this.state.bu}
                            market={this.state.market}
                            onCommit={this.commitTableQuery.bind(this)}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="数据集市" key="dataMarket">
                        <SearchView
                                levels={[
                                    { key: 'DWD/DW', title: 'DWD/DW' },
                                    { key: 'DWS', title: 'DWS' },
                                    { key: 'ADS/DM', title: 'ADS/DM' },
                                    { key: 'DIM', title: 'DIM' }
                                ]}
                                bus={undefined}
                                markets = {storageMarket}
                                market = {this.state.market}
                                level={this.state.level}
                                area={this.state.area}
                                bu={this.state.bu}
                                onCommit={this.commitTableQuery.bind(this)}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="ODS" key="ODS">
                        <SearchView
                            bus={storageBus}
                            markets={undefined}
                            level={this.state.level}
                            area={this.state.area}
                            bu={this.state.bu}
                            market={this.state.market}
                            onCommit={this.commitTableQuery.bind(this)}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="全部" key="">
                        <SearchView
                            levels={storageLevels}
                            areas={storageVersionAreas.all}
                            bus={undefined}
                            markets={undefined}
                            market={this.state.market}
                            level={this.state.level}
                            area={this.state.area}
                            bu={this.state.bu}
                            onCommit={this.commitTableQuery.bind(this)}
                        />
                    </Tabs.TabPane>
                </Tabs>}
            </Row>
            <div style={{ height: 10 }} ></div>
            <Row>
                <Col flex="20%"  style={{ margin: '0 10px 0 0'}}>
                    <Input.Search
                        placeholder="表名搜索"
                        value={this.state.searchKey}
                        onChange={({ target: { value } }) => this.commitTableQuery({ searchKey: value })}
                        allowClear
                    ></Input.Search>
                </Col>
                <Col style={{ margin: '5px 10px 0 0'}}>
                        <Checkbox 
                        checked = {this.state.checkCollect} 
                        onChange={(e) => {
                            if (e.target.checked) {
                                this.setState({
                                    checkCollect: true
                                })
                                this.commitTableQuery({collectorView: this.state.userName})
                            } else {
                                this.setState({
                                    checkCollect: false
                                })
                                this.commitTableQuery({ collectorView: ''})    
                            }
                    }}>收藏列表</Checkbox>
                </Col>
            </Row>
            <div style={{ height: 10 }} ></div>
            <Row>
                <Table
                    dataSource={this.state.schemas}
                    pagination={false}
                    bordered
                    size="small"
                    style={{
                        width: '100%',
                        //height: this.state.tableHeight,
                        //overflowX: 'auto',
                        //overflowY: 'auto'
                    }}
                    scroll={{ y: this.state.tableHeight }}
                >
                    <Table.Column
                        dataIndex="name"
                        key="name"
                        width={200}
                        ellipsis
                        title="表名称"
                        render={(value, record) => <>
                            <Link to={`/schema_desc/detail/${this.props.projectName}/${value}`}>{value}</Link>
                        </>}
                    />
                    <Table.Column
                        dataIndex="comment"
                        key="comment"
                        width={220}
                        ellipsis
                        title="表描述"
                    />
                    <Table.Column
                        dataIndex="usageHeat"
                        key="usageHeat"
                        width={110}
                        ellipsis
                        title="表热度"
                        render={value => <Rate disabled character={<FireOutlined />} value={value} style={{ fontSize: 15, color: '#fa541c' }} />}
                    />
                    <Table.Column
                        dataIndex="modifiedTime"
                        key="updatedAt"
                        width={90}
                        align="left"
                        title="数据更新时间"
                    />
                    {this.state.version === 'ODS' && <>
                        <Table.Column
                            dataIndex="bu"
                            key="bu"
                            width={60}
                            ellipsis
                            title="所属业务线"
                        />
                    </>}
                    {this.state.version === 'dataStorage' && <>
                        <Table.Column
                            dataIndex="area"
                            key="area"
                            width={60}
                            ellipsis
                            title="主题归属"
                        />
                    </>}
                    {this.state.version === 'dataMarket' && <>
                        <Table.Column
                            dataIndex="market"
                            key="area"
                            width={100}
                            ellipsis
                            title="所属集市"
                        />
                    </>}
                        <Table.Column
                            title="操作"
                            key="operators"
                            dataIndex="id"
                            fixed="right"
                            width={100}
                            render={(id, record) => <>
                                {this.isDefaultProject() && <Tooltip title="编辑">
                                 {auth.allow("datap:admin") && 
                                    <Button
                                        type="link"
                                        style={{ padding: '7px' }}
                                        icon={<EditTwoTone />}
                                        onClick={() =>{
                                            if (auth.allow("datap:admin")) {
                                                this.setState({
                                                    tagsModal: {
                                                        visible: true,
                                                        title: '修改表属性',
                                                        schema: record.name,
                                                        version: record.version,
                                                        area: record.area,
                                                        bu: record.bu,
                                                        comment: record.comment,
                                                        remark: '',
                                                        market: record.market,
                                                    }
                                                });
                                            }
                                        }}
                                    ></Button>}
                                </Tooltip>}
                                <Tooltip title="收藏">
                                    {record.collect === 0
                                        ? <Button
                                        type="link"
                                        style={{ padding: '7px' }}
                                        icon={<StarTwoTone/>}
                                        onClick={()=> {
                                            this.collectSaved(id, record)
                                        }}
                                         ></Button>
                                        :<Button
                                        type="link"
                                        style={{ padding: '7px' }}
                                        icon={<StarFilled />}
                                        onClick={()=> {
                                            this.collectCancel(id, record)
                                        }}
                                    
                                    ></Button>
                                    }
                                </Tooltip>
                            </>}
                        />
                </Table>
            </Row>
            <Row>
                <Col>
                    <Space>
                        <span>总数: {this.state.total}</span>
                        <span>占用空间: {this.makeSpaceSizeNodes(this.state.sizeInBytes)}</span>
                    </Space>
                </Col>
                <Col flex="auto"></Col>
                <Col>
                    <Pagination
                        size="small"
                        current={this.state.pageNo}
                        pageSize={this.state.pageSize}
                        total={this.state.total}
                        onChange={(pageNo, pageSize) => this.commitTableQuery({ pageNo, pageSize })}
                        onShowSizeChange={(_, pageSize) => this.commitTableQuery({ pageNo: 1, pageSize })}
                    />
                </Col>
            </Row>
            {this.state.tagsModal.visible && <TagsModal
                {...this.state.tagsModal}
                onCancel={() => this.setState(({ tagsModal }) => {
                    tagsModal.visible = false;
                    return { tagsModal };
                })}
                onOk={(name, tags, version) => {
                    if (version === 'dataMarket') {
                        if (tags.market === undefined) {
                            message.error("请选择数据集市")
                        } else {
                            this.changeVersion(name, tags)
                        }
                    } else {
                        this.changeVersion(name, tags)
                    }
             
                }}
            />}
        </>;
    }

    changeVersion(name, tags) {
        this.commitSchemaTags(name, tags);
        this.setState(({ tagsModal }) => {
            tagsModal.visible = false;
            return { tagsModal };
        });
    }

    async collectSaved(id, record) {
        await UIFetchService.put(`/api/v1/schema/schemas/${this.props.projectName}/collect/${record.name}`);
        await this.commitTableQuery({ pageNo: this.state.pageNo });
    }

    async collectCancel(id, record) {
        await UIFetchService.delete(`/api/v1/schema/schemas/${this.props.projectName}/collect/${record.name}`, {});
        await this.commitTableQuery({ pageNo: this.state.pageNo });
    }

    makeExtraInfosNodes(infos) {
        if (isEmpty(infos[0])) {
            return <Tag color="#595959">内部表</Tag>
        }
        return <Space>
            {infos.map(key => <Tag color={storageTableExtraInfos[key].color}>{storageTableExtraInfos[key].title}</Tag>)}
        </Space>
    }

    makeSpaceSizeNodes(size) {
        if (size === null || size === undefined) {
            return <></>
        }
        const rv = getSpaceSizeUnit(size);
        return <code style={{ color: storageSpaceSizeColors[rv.unit] }}>{formatSpaceSize(size)}</code>
    }

    async commitSchemaTags(name, tags) {
        await UIFetchService.put(`/api/v1/schema/schemas/${this.props.projectName}/${name}/tags`, tags);
        await this.commitTableQuery({ pageNo: this.state.pageNo });
        message.success(`更新表："${name}"属性成功`);
    }

    async commitTableQuery(params) {
        if (!('version' in params)) {
            params.version = this.state.version;
        } else {
            if (params.version === 'ODS') {
                params.level = 'ODS';
            } else {
                params.level = 'all';
                params.bu = 'all';
            }
        }
        if (!('pageSize' in params)) {
            params.pageSize = this.state.pageSize;
        }
        if (!('pageNo' in params)) {
            params.pageNo = this.state.pageNo;
        }
        if (!('level' in params)) {
            params.level = this.state.level;
        } else {
            params.pageNo = 1;
        }
        if (!('area' in params)) {
            if (params.version === 'dataStorage') {
                params.area = this.state.area;
            } else {
                params.area = 'all';
            }
        } else {
            params.pageNo = 1;
        }
        if (!('bu' in params)) {
            params.bu = this.state.bu;
        } else {
            params.pageNo = 1;
        }
        if (!('market' in params)) {
            if (params.version === 'dataStorage' || params.version === 'ODS') {
                params.market = 'all'
            } else {
                params.market = this.state.market;
            }
        } else {
            params.pageNo = 1;
        }
        if (!('searchKey' in params)) {
            params.searchKey = this.state.searchKey;
        } else {
            params.pageNo = 1;
        }
        if (params.level === 'ADS/DM' || params.level === 'DIM') {
            this.setState({
                areaEnter: false 
            })
            params.area = 'all'
        } else {
            this.setState({
                areaEnter: true
            })
        }

        if (!('collectorView' in params)) {
            params.collectorView =  this.state.collectorView
            if (params.collectorView !== '')  {
                this.setState({
                    checkCollect: true
                })
            }
        } else {
            params.pageNo = 1;
        }


        let query = ''
        for (let key of Object.keys(params)) {
            if (query.length > 0) {
                query = `${query}&${key}=${encodeURI(params[key])}`;
            } else {
                query = `${key}=${encodeURI(params[key])}`;
            }
        }
        this.setState({ ...params });
        localStorage.setItem(`${this.props.projectName}.dataMap.schemas`, JSON.stringify(params));
        UIFetchService.get(`/api/v1/metadata/schemas/${this.props.projectName}/specified?${query}`)
            .then(result => this.setState({ schemas: result.items, total: result.total, sizeInBytes: result.sizeInBytes }));
    }

    isDefaultProject() { return this.props.projectName === 'bcz_datap'; }
}

class TagsModal extends React.Component {
    constructor() {
        super();
        this.state = {
            version: '',
            area: '',
            bu: '',
            remark: '',
            market: '',
        };
    }

    componentDidMount() {
        this.setState({
            version: this.props.version,
            area: this.props.area,
            bu: this.props.bu,
            remark: this.props.remark,
            market: this.props.market
        });
    }

    render() {
        const formItemStyle = {
            margin: '0px 0px 10px 0px',
        }

        return <Modal
            visible={this.props.visible}
            title={this.props.title}
            onCancel={this.props.onCancel}
            onOk={() => this.props.onOk(this.props.schema, this.state, this.state.version)}
        >
            <Row justify="space-around">
                <Col flex="100%">
                    <Form
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 20 }}
                        layout="horizontal"
                    >
                        <Form.Item
                            label="表名"
                            style={formItemStyle}
                        >
                            <code style={{ color: '#2f54eb', margin: '0 20px 0 0' }}>{this.props.schema}</code>
                            <em style={{ color: '#389e0d' }}>{`// ${this.props.comment}`}</em>
                        </Form.Item>
                        {this.isNotODS()&&<Form.Item
                            label="归属"
                            style={formItemStyle}
                        >
                            <Radio.Group
                                value={this.state.version}
                                onChange={({ target: { value } }) => {
                                    this.setState({ version: value })
                                    if (value === 'dataStorage') {
                                        this.setState({market: null})
                                    } else if (value === 'dataMarket'){
                                        this.setState({area: null})
                                    }
                                }}
                            >
                                <Radio value="dataStorage">数仓</Radio>
                                <Radio value="dataMarket">数据集市</Radio>
                            </Radio.Group>
                        </Form.Item>}
                        {this.isODS() && <Form.Item
                            label="业务线"
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.bu}
                                onChange={bu => this.setState({ bu })}
                            >
                                {storageBus.map(bu => <Select.Option value={bu.key}>{bu.title}</Select.Option>)}
                            </Select>
                        </Form.Item>}
                        {this.isNotODS() && this.isDataStorage() && <Form.Item
                            label="主题域"
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.area}
                                onChange={area => this.setState({ area })}
                            >
                                {this.currentAreas().map(area => <Select.Option value={area.key}>{area.title}</Select.Option>)}
                            </Select>
                        </Form.Item>}
                        {this.isNotODS() && this.isNotDataStorage() && <Form.Item
                            label="所属集市"
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.market}
                                onChange={market=> this.setState({ market })}
                            >
                                {storageMarket.map(market => <Select.Option value={market.key}>{market.title}</Select.Option>)}
                            </Select>
                        </Form.Item>}
                        <Form.Item
                            label="备注"
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                value={this.state.remark}
                                onChange={({ target: { value } }) => this.setState({ remark: value })}
                            >
                            </Input.TextArea>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Modal>;
    }

    isODS() { return this.props.schema?.startsWith('ods_'); }
    isNotODS() { return !this.isODS(); }
    isDataStorage() { return this.state.version === 'dataStorage';}
    isNotDataStorage() {return !this.isDataStorage();}

    currentAreas() {
        const areas = storageVersionAreas[this.state.version];
        return areas === undefined ? storageFlattenAreas : areas;
    }
}

class SearchView extends React.Component {

    titlePixls = '80px'

    render() {
        return <>
            {this.props.markets !== undefined && <>
             <div style={{ height: 10 }} ></div>
             <Row>
                <Col style={{ alignSelf: 'center', textAlign: 'start' }} flex={this.titlePixls}>
                    <span style={{ fontSize: 12 }}>{'所属集市:'}</span>
                </Col>
                <Col>
                    <Radio.Group
                        size="small"
                        buttonStyle="solid"
                        value={this.props.market}
                        onChange={({ target: { value } }) => this.props.onCommit({ market: value })}
                    >
                        <Radio.Button value="all">全部</Radio.Button>
                        {this.props.markets.map(item => <Radio.Button value={item.key}>{item.title}</Radio.Button>)}
                    </Radio.Group>
                </Col>
            </Row>
        </>}
            {this.props.levels !== undefined && <>
                <div style={{ height: 10 }} ></div>
                <Row>
                    <Col style={{ alignSelf: 'center', textAlign: 'start' }} flex={this.titlePixls}>
                        <span style={{ fontSize: 12 }}>表分层: </span>
                    </Col>
                    <Col>
                        <Radio.Group
                            size="small"
                            buttonStyle="solid"
                            value={this.props.level} 
                            onChange={({ target: { value } }) => this.props.onCommit({ level: value })}
                        >
                            <Radio.Button value="all">全部</Radio.Button>
                            {this.props.levels.map(level => <Radio.Button value={level.key}>{level.title}</Radio.Button>)}
                        </Radio.Group>
                    </Col>
                </Row>
            </>}
            <div style={{ height: 10 }} ></div>
            {this.props.areaEnter && this.props.areas !== undefined && <Row>
                <Col style={{ alignSelf: 'center', textAlign: 'start' }} flex={this.titlePixls}>
                    <span style={{ fontSize: 12 }}>{'所属主题域:'}</span>
                </Col>
                <Col>
                    <Radio.Group
                        size="small"
                        buttonStyle="solid"
                        value={this.props.area}
                        onChange={({ target: { value } }) => this.props.onCommit({ area: value })}
                    >
                        <Radio.Button value="all">全部</Radio.Button>
                        {this.props.areas.map(item => <Radio.Button value={item.key}>{item.title}</Radio.Button>)}
                    </Radio.Group>
                </Col>
            </Row>}
            {this.props.bus !== undefined && <Row>
                <Col style={{ alignSelf: 'center', textAlign: 'start' }} flex={this.titlePixls}>
                    <span style={{ fontSize: 12 }}>{'所属业务线:'}</span>
                </Col>
                <Col>
                    <Radio.Group
                        size="small"
                        buttonStyle="solid"
                        value={this.props.bu}
                        onChange={({ target: { value } }) => this.props.onCommit({ bu: value })}
                    >
                        <Radio.Button value="all">全部</Radio.Button>
                        {this.props.bus.map(item => <Radio.Button value={item.key}>{item.title}</Radio.Button>)}
                    </Radio.Group>
                </Col>
            </Row>}
        </>
    }
}

export default SchemaDescView;